import React from 'react';
import {
  Box, Stack, Typography, IconButton, Button,
  Paper, Dialog, DialogTitle, DialogContent, DialogActions,
  MenuItem, TextField, FormControl, InputLabel, Select,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { green, blue, grey, red, orange } from '@mui/material/colors';
import { motion } from 'framer-motion';
import { leadEncerramentoMotivo } from '../../../constants/crm';

export default function LeadEncerramento({
  lead,
  showEncerrarLead,
  handleCloseEncerrarLead,
  handleEncerrarLead,
  motivoEncerramento,
  setMotivoEncerramento,
  observacaoEncerramento,
  setObservacaoEncerramento,
  loadingEncerrar
}) {

  return (
    <>
      {/* Dialog para Encerrar o Lead */}
      <Dialog
        open={showEncerrarLead}
        onClose={handleCloseEncerrarLead}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          elevation: 5,
          sx: { borderRadius: 2 }
        }}
        TransitionProps={{
          component: motion.div,
          variants: {
            hidden: { opacity: 0, y: -50 },
            visible: { opacity: 1, y: 0 }
          },
          initial: "hidden",
          animate: "visible"
        }}
      >
        <DialogTitle sx={{
          bgcolor: red[600],
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1.5
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <CloseIcon />
            <Typography
              sx={{ fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' } }}
              fontWeight="bold">
              Encerrar Lead - {lead?.nome}
            </Typography>
          </Box>
          <IconButton
            onClick={handleCloseEncerrarLead}
            size="small"
            sx={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 3 }}>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <FormControl fullWidth variant="outlined" size="small" >
              <InputLabel id="motivo-encerramento-label">Motivo do Encerramento</InputLabel>
              <Select
                labelId="motivo-encerramento-label"
                id="motivo-encerramento"
                value={motivoEncerramento}
                label="Motivo do Encerramento"
                onChange={(e) => setMotivoEncerramento(e.target.value)}
                sx={{ minHeight: '40px' }}
              >
                <MenuItem value={leadEncerramentoMotivo.Vendido}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleIcon fontSize="small" sx={{ color: green[600] }} />
                    Venda Realizada
                  </Box>
                </MenuItem>
                <MenuItem value={leadEncerramentoMotivo.SemInteresse}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InfoIcon fontSize="small" sx={{ color: orange[600] }} />
                    Cliente não solicitou contato
                  </Box>
                </MenuItem>
                <MenuItem value={leadEncerramentoMotivo.Abandono}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CloseIcon fontSize="small" sx={{ color: red[600] }} />
                    Cliente Abandonou Negociação
                  </Box>
                </MenuItem>
                <MenuItem value={leadEncerramentoMotivo.SemInteresse}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InfoIcon fontSize="small" sx={{ color: orange[600] }} />
                    Cliente não tem Interesse
                  </Box>
                </MenuItem>
                <MenuItem value={leadEncerramentoMotivo.NaoAtendeu}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <MoreHorizIcon fontSize="small" sx={{ color: blue[600] }} />
                    Cliente não atendeu
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Observação"
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              placeholder="Adicione informações relevantes sobre o encerramento deste lead"
              value={observacaoEncerramento}
              onChange={(e) => setObservacaoEncerramento(e.target.value)}
              InputProps={{
                sx: {
                  borderRadius: 1,
                  bgcolor: grey[50]
                }
              }}
            />

            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderColor: orange[200],
                borderRadius: 1,
                bgcolor: orange[50]
              }}
            >
              <Box sx={{ display: 'flex', gap: 1.5 }}>
                <WarningIcon sx={{ color: orange[700], fontSize: 20, mt: 0.2 }} />
                <Typography variant="body2" color={orange[900]}>
                  <strong>Atenção:</strong> Ao encerrar este lead, ele será movido para a lista de leads encerrados
                  e não ficará mais disponível na sua lista de leads ativos. Esta ação não pode ser desfeita.
                </Typography>
              </Box>
            </Paper>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2.5, bgcolor: grey[50], borderTop: `1px solid ${grey[200]}` }}>
          <Button
            onClick={handleCloseEncerrarLead}
            variant="outlined"
            disabled={loadingEncerrar}
            size='small'
            sx={{ px: 3 }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleEncerrarLead}
            variant="contained"
            color="error"
            disabled={!motivoEncerramento || loadingEncerrar}
            startIcon={loadingEncerrar ? <CircularProgress size={20} color="inherit" /> : null}
            size='small'
            sx={{ px: 3 }}
          >
            {loadingEncerrar ? "Encerrando..." : "Confirmar Encerramento"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}